import React from "react";
// import Container from "@material-ui/core/Container";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";

const useStyles = makeStyles({
  grid: {
    margin: "0 -15px !important",
    width: "unset"
  }
});

export default props => {
  const classes = useStyles();
  const { children, ...rest } = props;
  return (
    // <Container maxWidth="lg">
    <div
      style={{
        maxWidth: "90%",
        textAlign: "center",
        margin: "0 auto",
        width: "100%"
      }}
    >
      <Grid container {...rest} className={classes.grid}>
        {children}
      </Grid>
    </div>
    // </Container>
  );
};
